import type { AxiosInstance } from '@aviata/platform-client';
import type { SeoPageQueryResponse, SeoReturnType } from './types';

export const seoApi = (http: AxiosInstance): SeoReturnType => {
  return {
    getPage(slug: string): Promise<SeoPageQueryResponse> {
      return http.get(`/seo-pages/api/pages/${slug}/`);
    },
  };
};
